import { useEffect, useState } from "react";

const useIsMobile = (breakpoint = 768) => {
    const query = `(max-width: ${breakpoint}px)`;
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== "undefined" ? window.matchMedia(query).matches : false
    );

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mediaQuery = window.matchMedia(query);
        const handler = (event) => setIsMobile(event.matches);

        setIsMobile(mediaQuery.matches);

        mediaQuery.addEventListener("change", handler);
        return () => mediaQuery.removeEventListener("change", handler);
    }, [query]);

    return isMobile;
};

export default useIsMobile;
